var map = {
	"./approve.png": "34ca",
	"./avatar-frame.png": "a3c6",
	"./chip.png": "4a48",
	"./crosshair.png": "6b27",
	"./crown.png": "26de",
	"./horn.png": "d954",
	"./name-frame.png": "3481",
	"./quest-fail.png": "cd38",
	"./quest-success.png": "3d81",
	"./reject.png": "eab0",
	"./shadow-circle-danger.png": "7d9b",
	"./shadow-circle.png": "cdd3",
	"./shield.png": "eb6e",
	"./sword.png": "a4ca",
	"./table.png": "188a",
	"./wood-banner.png": "02e1",
	"./x-mark.png": "ade3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74ed";